// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseUrl: 'https://luxengine.com',
  apiBaseUrl: 'https://api.dev.luxengine.com',
  lastVisitedAddressKey: 'lastAddress',
  environmentName: 'dev',
  // assetServiceUrl: 'https://assets.api.bwrm.com/api/v1/processor-2-assets',
  assetServiceUrl: "https://assetservice.dev.luxengine.com/api/v1/processor-2-assets",
  firebaseConfig: {
    apiKey: "AIzaSyAafRnM_10NhpYEsnz32iUQ6_r8nRyS9b8",
    authDomain: "bwrm-dev.firebaseapp.com",
    projectId: "bwrm-dev",
    storageBucket: "bwrm-dev-processor2-data",
    messagingSenderId: "232649552761",
    appId: "1:232649552761:web:46d491b7df8342d6c975a8"
  }
};
/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
